import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const VEHICLE_BLOCK_DELETE_RESOURCE = "vehicle-block" as const;
export const VEHICLE_BLOCK_DELETE_API_PATH = `/v1/${VEHICLE_BLOCK_DELETE_RESOURCE}/{uuid}` as const;

export type VehicleBlockDeleteResponse =
  paths[typeof VEHICLE_BLOCK_DELETE_API_PATH]["delete"]["responses"][200]["content"];

export const useVehicleBlockDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleBlockDeleteResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }: { uuid: string }) => {
      const response = await alphartisApiAxios.delete<VehicleBlockDeleteResponse>(
        `/v1/${VEHICLE_BLOCK_DELETE_RESOURCE}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_BLOCK_DELETE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: ["vehicle"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["relocation-order"],
        }),
      ]);
    },
  });
};
